import { render, staticRenderFns } from "./supervise_abnormal_edit.vue?vue&type=template&id=a63f9538&scoped=true&"
import script from "./supervise_abnormal_edit.vue?vue&type=script&lang=js&"
export * from "./supervise_abnormal_edit.vue?vue&type=script&lang=js&"
import style0 from "./supervise_abnormal_edit.vue?vue&type=style&index=0&id=a63f9538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63f9538",
  null
  
)

export default component.exports